import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { fetchMe } from "@/lib/api";
import { initClarity, tagClarityUser } from "@/lib/clarity";
import { setSentryUser } from "@/lib/sentry";
import { pingTelemetry } from "@/lib/telemetry";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Analytics: load Clarity once, tag the session whenever the user changes.
  useEffect(() => { initClarity(); pingTelemetry(); }, []);
  useEffect(() => { if (user) tagClarityUser(user); setSentryUser(user); }, [user]);

  const refresh = useCallback(async () => {
    try {
      const { data } = await fetchMe();
      setUser(data);
      return data;
    } catch (e) {
      setUser(null);
      return null;
    }
  }, []);

  useEffect(() => {
    // CRITICAL: If returning from OAuth callback, skip the /me check.
    // AuthCallback will exchange session_id and establish the session first.
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    (async () => {
      await refresh();
      setLoading(false);
    })();
  }, [refresh]);

  return (
    <AuthCtx.Provider value={{ user, loading, setUser, refresh }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
